// Fabriculture client-side currency / country switcher
// Shop base currency is INR (cannot be changed via API on this dev store).
// Default = Canada / CAD treated 1:1 with the existing INR amount.
// Other currencies are converted from CAD using live FX rates from
// frankfurter.app, with a baked-in baseline rate table as a safe fallback
// if the network call fails (so the displayed value always changes when
// the visitor switches countries).

(function () {
  // Currency display catalog: { code: [symbol, position, decimals] }
  var CURRENCIES = {
    CAD: ['$',    'before', 2],
    USD: ['US$',  'before', 2],
    EUR: ['€',    'before', 2],
    GBP: ['£',    'before', 2],
    AUD: ['A$',   'before', 2],
    NZD: ['NZ$',  'before', 2],
    SGD: ['S$',   'before', 2],
    HKD: ['HK$',  'before', 2],
    CHF: ['CHF ', 'before', 2],
    JPY: ['¥',    'before', 0],
    KRW: ['₩',    'before', 0],
    MYR: ['RM',   'before', 2],
    AED: ['د.إ ', 'before', 2],
    ILS: ['₪',    'before', 2],
    SEK: ['kr ',  'after',  2],
    DKK: ['kr ',  'after',  2],
    NOK: ['kr ',  'after',  2],
    PLN: ['zł ',  'after',  2],
    CZK: ['Kč ',  'after',  2]
  };

  // 28-country list — UI dropdown source of truth.
  // Each row: [iso2, country name, currency code]
  var COUNTRIES = [
    ['au', 'Australia',             'AUD'],
    ['at', 'Austria',               'EUR'],
    ['be', 'Belgium',               'EUR'],
    ['ca', 'Canada',                'CAD'],
    ['cz', 'Czechia',               'CZK'],
    ['dk', 'Denmark',               'DKK'],
    ['fi', 'Finland',               'EUR'],
    ['fr', 'France',                'EUR'],
    ['de', 'Germany',               'EUR'],
    ['hk', 'Hong Kong SAR',         'HKD'],
    ['ie', 'Ireland',               'EUR'],
    ['il', 'Israel',                'ILS'],
    ['it', 'Italy',                 'EUR'],
    ['jp', 'Japan',                 'JPY'],
    ['my', 'Malaysia',              'MYR'],
    ['nl', 'Netherlands',           'EUR'],
    ['nz', 'New Zealand',           'NZD'],
    ['no', 'Norway',                'NOK'],
    ['pl', 'Poland',                'PLN'],
    ['pt', 'Portugal',              'EUR'],
    ['sg', 'Singapore',             'SGD'],
    ['kr', 'South Korea',           'KRW'],
    ['es', 'Spain',                 'EUR'],
    ['se', 'Sweden',                'SEK'],
    ['ch', 'Switzerland',           'CHF'],
    ['ae', 'United Arab Emirates',  'AED'],
    ['gb', 'United Kingdom',        'GBP'],
    ['us', 'United States',         'USD']
  ];

  // Hard-coded baseline rates with CAD = 1.0 as the base. Used when
  // frankfurter.app is unreachable — guarantees prices change when the
  // visitor switches country, even fully offline.
  var BASELINE_RATES_CAD_BASE = {
    CAD: 1.000, USD: 0.730, EUR: 0.668, GBP: 0.572, AUD: 1.114,
    NZD: 1.218, SGD: 0.957, HKD: 5.671, CHF: 0.620, JPY: 113.4,
    KRW: 1063.0, MYR: 3.43, AED: 2.681, ILS: 2.69, SEK: 7.87,
    DKK: 4.985, NOK: 8.18, PLN: 2.83, CZK: 17.05
  };

  var DEFAULT_COUNTRY = 'ca';
  var COUNTRY_KEY = 'fcCountry';
  var CURRENCY_KEY = 'fcCurrency';
  var RATES_KEY    = 'fcRates';
  var RATES_TTL_MS = 12 * 60 * 60 * 1000; // 12h

  // Two source formats this converter understands:
  //   1) "Rs. 1,234.50" / "₹ 1,234.50" / "INR 1,234.50"  (legacy INR-rendered pages — cart, collections, etc.)
  //   2) "$ 1,234.50 CAD" / "$1,234.50 CAD"               (new PDP renders directly in CAD as the source)
  // Both are treated as base = CAD 1:1 (per brand decision) and converted to the visitor's currency.
  var INR_RE = /(?:Rs\.\s?|₹\s?|INR\s?)((?:\d{1,3}(?:[,]\d{3})*|\d+)(?:[.]\d{1,2})?)/g;
  var CAD_RE = /\$\s?((?:\d{1,3}(?:[,]\d{3})*|\d+)(?:[.]\d{1,2})?)\s?CAD/g;

  function findCountry(iso) {
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (COUNTRIES[i][0] === iso) return COUNTRIES[i];
    }
    return null;
  }

  function selectedCountry() {
    try {
      var saved = localStorage.getItem(COUNTRY_KEY);
      if (saved && findCountry(saved)) return saved;
    } catch (e) {}
    return DEFAULT_COUNTRY;
  }

  function selectedCurrency() {
    var c = findCountry(selectedCountry());
    return c ? c[2] : 'CAD';
  }

  function setSelected(iso) {
    var c = findCountry(iso);
    if (!c) return;
    try {
      localStorage.setItem(COUNTRY_KEY, c[0]);
      localStorage.setItem(CURRENCY_KEY, c[2]);
    } catch (e) {}
  }

  function loadCachedRates() {
    try {
      var raw = localStorage.getItem(RATES_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || !obj.rates) return null;
      if (Date.now() - obj.ts > RATES_TTL_MS) return null;
      return obj.rates;
    } catch (e) { return null; }
  }

  function fetchRates(cb) {
    fetch('https://api.frankfurter.app/latest?from=CAD')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.rates) return cb(null);
        var rates = j.rates;
        rates.CAD = 1;
        try {
          localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), rates: rates }));
        } catch (e) {}
        cb(rates);
      })
      .catch(function () { cb(null); });
  }

  function ensureRates(cb) {
    var cached = loadCachedRates();
    if (cached) { cb(cached); return; }
    fetchRates(function (live) {
      cb(live || BASELINE_RATES_CAD_BASE);
    });
  }

  function fmt(amount, code) {
    var meta = CURRENCIES[code] || CURRENCIES.CAD;
    var sym = meta[0], pos = meta[1], dec = meta[2];
    var n = amount.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pos === 'before' ? (sym + n + ' ' + code) : (n + ' ' + sym + code);
  }

  function rewriteIn(node, ccy, rates) {
    if (!node) return;
    var rate = rates[ccy];
    if (rate == null) rate = BASELINE_RATES_CAD_BASE[ccy] || 1;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue) return NodeFilter.FILTER_REJECT;
        if (!/(?:Rs\.|₹|INR|\$\s?\d[\d,.]*\s?CAD)/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        while (p) {
          var t = p.tagName;
          if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
          p = p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var convert = function (_, amtStr) {
      var amt = parseFloat(amtStr.replace(/,/g, ''));
      if (isNaN(amt)) return _;
      // Source amount is treated as CAD-base 1:1 by brand decision; convert to ccy.
      return fmt(amt * rate, ccy);
    };
    var changes = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      // Apply CAD pattern first (more specific — anchored on the trailing " CAD"),
      // then INR pattern, so we never double-process the same substring.
      var newText = n.nodeValue.replace(CAD_RE, convert).replace(INR_RE, convert);
      if (newText !== n.nodeValue) changes.push([n, newText]);
    }
    for (var i = 0; i < changes.length; i++) changes[i][0].nodeValue = changes[i][1];
  }

  function rewriteAll() {
    var ccy = selectedCurrency();
    ensureRates(function (rates) {
      rewriteIn(document.body, ccy, rates);
      // Refresh any UI badge showing the active currency code/symbol.
      document.querySelectorAll('[data-fc-currency-label]').forEach(function (el) {
        var meta = CURRENCIES[ccy];
        var sym = (meta && meta[0]) || '$';
        el.textContent = ccy + ' (' + sym.trim() + ')';
      });
      // Refresh the active country flag in the trigger button.
      var iso = selectedCountry();
      document.querySelectorAll('[data-fc-country-flag]').forEach(function (el) {
        el.src = 'https://flagcdn.com/w40/' + iso + '.png';
        var c = findCountry(iso);
        if (c) el.alt = c[1] + ' flag';
      });
    });
  }

  // Public API used by the footer dropdown
  window.FCCurrency = {
    countries: COUNTRIES,
    currencies: CURRENCIES,
    getCountry: selectedCountry,
    getCurrency: selectedCurrency,
    set: function (codeOrIso) {
      // Accept either an ISO country code (e.g. 'us') or a 3-letter currency
      // code (e.g. 'USD') for backwards compatibility with old buttons.
      var iso = (codeOrIso || '').toLowerCase();
      if (!findCountry(iso)) {
        // try as currency code → first matching country wins
        var ccy = (codeOrIso || '').toUpperCase();
        for (var i = 0; i < COUNTRIES.length; i++) {
          if (COUNTRIES[i][2] === ccy) { iso = COUNTRIES[i][0]; break; }
        }
      }
      if (!findCountry(iso)) return;
      setSelected(iso);
      // Reload so server-rendered prices come back as fresh INR strings.
      location.reload();
    },
    setCountry: function (iso) { this.set(iso); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteAll);
  } else {
    rewriteAll();
  }
  document.addEventListener('cart:refresh', rewriteAll);
  document.addEventListener('cart:updated', rewriteAll);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var ccy = selectedCurrency();
      var rates = loadCachedRates() || BASELINE_RATES_CAD_BASE;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) rewriteIn(added[j], ccy, rates);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
